/* ============================================================
   Afterglow — lifestyle photo row
   The row itself is a pure CSS marquee, so there is nothing to
   drag, nothing to swipe, and no scroll container that could eat
   a vertical swipe. All this script does is the pause button.
   ============================================================ */

(function () {
  function wire(root) {
    if (root.dataset.agWired === 'true') return;
    root.dataset.agWired = 'true';

    var toggle = root.querySelector('[data-ag-strip-toggle]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setPaused(paused) {
      root.dataset.paused = paused ? 'true' : 'false';
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      toggle.setAttribute('aria-label', paused ? 'Play the photo row' : 'Pause the photo row');
    }

    // Anyone who asked for less motion gets it stopped from the start,
    // but the button still lets them start it if they want.
    setPaused(root.dataset.autoplay === 'false' || reduce.matches);

    if (toggle) {
      toggle.addEventListener('click', function () {
        setPaused(root.dataset.paused !== 'true');
      });
    }

    if (reduce.addEventListener) {
      reduce.addEventListener('change', function (e) { if (e.matches) setPaused(true); });
    }
  }

  function init() {
    document.querySelectorAll('[data-ag-strip]').forEach(wire);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // The theme editor re-renders sections in place.
  document.addEventListener('shopify:section:load', init);
})();
